import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-ship-plan',
  templateUrl: './member-ship-plan.component.html',
  styleUrls: ['./member-ship-plan.component.css']
})
export class MemberShipPlanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
